import { ThemeEvents } from '@theme/events';

if (!customElements.get('sc-product-properties')) {
  customElements.define(
    'sc-product-properties',
    class extends HTMLElement {
      #variantsById = {};

      /** @param {Event} event */
      #onVariantUpdate = (event) => {
        const detail = /** @type {{ detail?: { resource?: { id?: string | number }, data?: { productId?: string | number } } }} */ (
          event
        ).detail;
        const productId = detail?.data?.productId;
        if (productId && this.dataset.productId && String(productId) !== String(this.dataset.productId)) {
          return;
        }

        const variantId = detail?.resource?.id;
        if (variantId == null) return;

        const meta = this.#variantsById[String(variantId)];
        if (!meta) return;

        const weightEl = this.querySelector('[data-sc-variant-weight]');
        const skuEl = this.querySelector('[data-sc-variant-sku]');
        if (weightEl && meta.weight != null) weightEl.textContent = meta.weight;
        if (skuEl && meta.sku != null) skuEl.textContent = meta.sku;
      };

      connectedCallback() {
        this.toggleBtn = this.querySelector('.sc-product-properties__toggle');

        if (this.toggleBtn) {
          this.toggleBtn.addEventListener('click', () => {
            const isExpanded = this.classList.toggle('is-expanded');
            this.toggleBtn?.setAttribute('aria-expanded', isExpanded.toString());
          });
        }

        const jsonEl = this.querySelector('[data-sc-variant-rows]');
        if (jsonEl?.textContent) {
          try {
            this.#variantsById = JSON.parse(jsonEl.textContent);
          } catch {
            this.#variantsById = {};
          }
        }

        document.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
      }

      disconnectedCallback() {
        document.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
      }
    },
  );
}
